// extracted by mini-css-extract-plugin
export default {"c-label":"Label_c-label__0Oj51","c-label__text":"Label_c-label__text__OCs0k"};